import Manager from 'coreClasses/Manager';
import {RouteInfo} from 'sfccAPI/interfaces';
import {cloneObject} from 'coreUtils/utils';

/**
 * Represents RouterMgr
 */
class RouterMgr extends Manager {
	private map: Map<string, null|RouteInfo> = new Map();

	/**
	 * Register a pathname
	 * @param {string} pathname - path name
	 * @param {object} routeInfo - route info
	 * @return {Promise<any>} - promise to wait for
	 */
	registerRoute(pathname: string, routeInfo: RouteInfo): void {
		this.map.set(pathname, {jsonld: [], ...routeInfo});
	}

	/**
	 * Gets routeInfo based on pathname
	 * @param {string} pathname - path name
	 */
	getRoute(pathname: string): object {
		if (this.map.has(pathname)) {
			return cloneObject(this.map.get(pathname));
		} else {
			return null;
		}
	}
}

export default RouterMgr;
